import React, { useState, Fragment, useEffect, useContext } from 'react';
import './index.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import {
  deletePharmacyCoupon,
  deleteAllCoupons,
  deleteDrugCoupon,
  editCoupon
} from '../../../services/Api/SaveCoupon/SaveCouponService';
import { getSavedCoupons } from '../../../actions/userDrug';
import EditViewModal from '../EditViewModal';
import DialogModel from '../Component/Dialog';
import DeleteEditAction from '../Component/Action';
import NoCoupons from '../NoCoupons';
import ActionButton from '../Component/Button';
import DrugDropdownModal from '../drugDropdownModal';
import Loader from '../../common/Loader';
import CouponModal from '../../prescription-2/CouponModal/index.jsx';
import GetFreeCoupon from '../../common/GetFreeCoupon/index';
import {
  LOYALTY_SIGNUP_MODAL,
  SOFT_COUPON_MODAL
} from '../../../constants/defaults.js';
import { AuthContext } from '../../../Contexts.js';

const MainSaveCouponsList = props => {
  const [savedCouponData, setSavedCouponData] = useState([]);
  const [isOpened, setIsOpened] = useState(false);
  const [isEditCouponDrug, setIsEditCouponDrug] = useState(false);
  const [isDeleteCouponDrug, setIsDeleteCouponDrug] = useState(false);
  const [isClearAllCoupons, setClearAllCoupons] = useState(false);
  const [isDeletePharmacy, setIsDeletePharmacy] = useState(false);
  const [pharmacyData, setPharmacyData] = useState();
  const [deleteDrugData, setDeleteDrugData] = useState({});
  const [editDrugData, setEditDrugData] = useState();
  const [isLoading, setLoading] = useState(true);
  const [notificationError, setNotificationError] = useState('');
  const [dataLayerEventObj, setDataLayerEventObj] = useState({});
  const [couponItems, setCouponItems] = useState([]);
  const [isModalOpen, setModalVisibility] = useState(false);
  const [showSignupModal, setSignupModal] = useState(false);
  const [selectedCouponData, setSelectedCouponData] = useState([]);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const storeItem = useSelector(state => state.modal.item);
  const modalState = useSelector(state => state.modal.modal);

  useEffect(() => {
    setLoading(true);
    props.getSavedCoupons();
  }, []);

  useEffect(() => {
    setSavedCouponData(props.savedCouponData);
    setLoading(false);
    setCouponItems(
      props.savedCouponData &&
        props.savedCouponData.couponItems &&
        props.savedCouponData.couponItems.map(coupon => ({
          ...coupon,
          isEditLoading: false
        }))
    );
  }, [props.savedCouponData]);

  useEffect(() => {
    isModalOpen
      ? document.body.classList.add('blockScroll')
      : document.body.classList.remove('blockScroll');
    _.getIsMobileDevice()
      ? (document.body.style.position = isModalOpen ? 'fixed' : '')
      : null;
  }, [isModalOpen]);

  const handleEditSuccess = async (quantity, isCustomQuantity, quantityObj) => {
    _.triggerGTMVirtualPageViewEvent({
      event: 'editDrugSubmit',
      drugName: dataLayerEventObj.drugName,
      seoName: dataLayerEventObj.seoName,
      NDC: quantityObj.ndc,
      drugBrand: quantityObj?.drugType
        ? quantityObj?.drugType
        : quantityObj.isGeneric
        ? 'Generic'
        : 'Brand',
      drugForm: quantityObj.form,
      drugDosage: quantityObj.dosage,
      drugQuantity: quantity
    });
    setIsEditCouponDrug(false);
    const editCouponResponse = await editCoupon(
      editDrugData.id,
      quantityObj.ndc,
      quantity,
      savedCouponData.saveCouponId,
      isCustomQuantity
    );
    if (editCouponResponse && editCouponResponse.saveCouponId) {
      props.getSavedCoupons();
    } else {
      // Set loading of each coupon to false for API error
      setCouponItems(
        props.savedCouponData &&
          props.savedCouponData.couponItems &&
          props.savedCouponData.couponItems.map(coupon => ({
            ...coupon,
            isEditLoading: false
          }))
      );
      const errorMessage =
        editCouponResponse.message.code === 6
          ? 'The coupon is already saved.'
          : 'Something went wrong.';
      setNotificationError(errorMessage);
      setTimeout(() => {
        setNotificationError('');
      }, 3000);
    }
  };

  const handleDeletePharmacy = async () => {
    // ndc and couponId
    const deletePharmcyResponse = await deletePharmacyCoupon(
      pharmacyData,
      savedCouponData.saveCouponId
    );
    if (deletePharmcyResponse && deletePharmcyResponse.saveCouponId) {
      _.triggerGTMVirtualPageViewEvent({
        event: 'deleteCouponConfirm',
        drugName: dataLayerEventObj.drugName,
        seoName: dataLayerEventObj.seoName,
        NDC: dataLayerEventObj.ndc,
        drugBrand: dataLayerEventObj?.drugType
          ? dataLayerEventObj?.drugType
          : dataLayerEventObj.isGeneric
          ? 'Generic'
          : 'Brand',
        drugForm: dataLayerEventObj.form,
        drugDosage: dataLayerEventObj.dosage,
        drugQuantity: dataLayerEventObj.quantity,
        pharmacyName: dataLayerEventObj.pharmacy,
        chainCode: dataLayerEventObj.chainCode,
        pharmacyPrice: dataLayerEventObj.price,
        loyaltyPrice: dataLayerEventObj.loyaltyPrice,
        loyaltyApplicable: dataLayerEventObj.loyaltyApplicable,
        loyaltyExcluded: dataLayerEventObj.loyaltyExcluded,
        bonusSavings: dataLayerEventObj.loyaltyBonusSavings,
        GPI: dataLayerEventObj.gpi,
        pharmacyDistance: dataLayerEventObj.distance
      });
      props.getSavedCoupons();
    }
    setIsDeletePharmacy(false);
  };

  const handleDeleteAllCoupons = async () => {
    // couponId
    const deleteAllCouponResponse = await deleteAllCoupons(
      savedCouponData.saveCouponId
    );
    if (deleteAllCouponResponse && deleteAllCouponResponse.success) {
      // handle success
      setSavedCouponData({});
      props.getSavedCoupons();
    }
    setClearAllCoupons(false);
  };

  const handleDeleteCouponDrug = async () => {
    // ndc, quantity
    const deleteDrugCouponResponse = await deleteDrugCoupon(
      deleteDrugData.ndc,
      deleteDrugData.quantity
    );
    if (deleteDrugCouponResponse && deleteDrugCouponResponse.saveCouponId) {
      // calling get API to refresh list
      _.triggerGTMVirtualPageViewEvent({
        event: 'savedDrugsDeleteDrugConfirm',
        drugName: dataLayerEventObj.drugName,
        seoName: dataLayerEventObj.seoName,
        NDC: dataLayerEventObj.ndc,
        drugBrand: dataLayerEventObj?.drugType
          ? dataLayerEventObj?.drugType
          : dataLayerEventObj.isGeneric
          ? 'Generic'
          : 'Brand',
        drugForm: dataLayerEventObj.form,
        drugDosage: dataLayerEventObj.dosage,
        drugQuantity: dataLayerEventObj.quantity
      });
      props.getSavedCoupons();
    }
    setIsDeleteCouponDrug(false);
  };

  const getItemList = coupon => {
    return {
      Prices: [
        {
          LoyaltyApplicable: coupon.loyaltyApplicable,
          LoyaltyBonusSavings: coupon.loyaltyBonusSavings,
          LoyaltyDiscounts: coupon.loyaltyDiscounts,
          LoyaltyExcluded: coupon.loyaltyExcluded,
          LoyaltyPrice: coupon.loyaltyPrice,
          PBAClientId: coupon.pBAClientId,
          PBAClientName: coupon.pBAClientName,
          PartnerPassword: coupon.partnerPassword,
          PartnerUser: coupon.partnerUser,
          Price: coupon.price,
          preferredNdc: coupon.preferredNdc
        }
      ],
      Pharmacy: {
        Distance: coupon.distance,
        LogoUrl: coupon.pharmacyLogoUrl,
        Name: coupon.pharmacy,
        chainCode: coupon.ncpdpChaincode,
        nabp: coupon.nabp,
        network: coupon.inNetworkPharmacy,
        onlinePharmacy: coupon.onlinePharmacy
      }
    };
  };

  const getDrugData = drug => {
    return {
      displayQuantity: drug.displayQuantity,
      dosage: drug.dosage,
      form: drug.form,
      isGeneric: drug.isGeneric,
      isSpecialityDrug: drug.isSpecialtyDrug,
      name: drug.drugName,
      ndc: drug.ndc,
      quantity: drug.quantity,
      seoName: drug.seoName,
      drugType: drug?.drugType
    };
  };

  const checkPharmacyName =
    couponItems &&
    couponItems
      .filter(couponItem => couponItem.drug.isSpecialtyDrug !== null)
      .some(couponItem =>
        couponItem.coupons.some(
          coupon =>
            getItemList(coupon)?.Pharmacy?.Name === storeItem?.Pharmacy?.Name
        )
      );

  const getDrugItemList = () => {
    return (
      couponItems &&
      couponItems
        .filter(couponItem => couponItem.drug.isSpecialtyDrug !== null)
        .map(couponItem => getDrugData(couponItem?.drug))
    );
  };

  const onFreeCouponClick = (coupon, drugInfo) => {
    setSelectedCouponData({ coupon: coupon, drugData: drugInfo });
    let item = getItemList(coupon);
    let drugData = getDrugData(drugInfo);
    setModalVisibility(true);
    const cheapestPrices = item.Prices[0];
    let eventObj = {
      memberBalance: props.userPoints,
      drugName: drugData.name,
      seoName: drugData.seoName,
      NDC: cheapestPrices.preferredNdc,
      drugBrand: drugData?.drugType
        ? drugData?.drugType
        : drugData.isGeneric
        ? 'generic'
        : 'brand',
      drugForm: drugData.form,
      drugDosage: drugData.dosage,
      drugQuantity: drugData.quantity,
      drugQuantityUnit: 'count',
      pbm: cheapestPrices.pBAName,
      pharmacyPrice: cheapestPrices.Price,
      priceUsualAndCustomary: cheapestPrices.UsualAndCustomary,
      singlecarePrice: cheapestPrices.Price,
      lowestPrice: props.lowestPrice,
      lowestPricePharmacyName: props.lowestPricePharmacyName,
      loyaltyApplicable: cheapestPrices.LoyaltyApplicable,
      loyaltyBonusSavings: cheapestPrices.LoyaltyBonusSavings,
      loyaltyExcluded: cheapestPrices.LoyaltyExcluded,
      loyaltyPrice: cheapestPrices.LoyaltyPrice,
      maxPharmacyPosition: props.maxPharmacyPosition,
      GPI: drugData.gpi,
      network: item.Pharmacy.network,
      pharmacyNetPrice: cheapestPrices.LoyaltyPrice,
      memberSavings: !_.isEmpty(cheapestPrices.LoyaltyDiscounts)
        ? cheapestPrices.LoyaltyDiscounts[0].discountAmount
        : '',
      bonusSavings: cheapestPrices.LoyaltyBonusSavings
    };
    let finalEventObj = {
      ...eventObj,
      event: 'getFreeCouponClick',
      pharmacyName: item.Pharmacy.Name,
      pharmacyPosition: '',
      pharmacyDistance: item.Pharmacy.Distance,
      clickText: 'Get free coupon',
      network: item.Pharmacy.network,
      geniusRxPrice: props.geniusRxPrice
    };
    _.triggerGTMVirtualPageViewEvent(finalEventObj);
  };

  /*
   *  this code is for to open - last open coupon model
   *  here we check if user is from loyalty signup then open,
   *  previous open coupon model after signup/login
   *  */
  useEffect(() => {
    if (
      isLoggedIn &&
      (modalState === LOYALTY_SIGNUP_MODAL ||
        modalState === SOFT_COUPON_MODAL) &&
      !_.isEmpty(storeItem) &&
      checkPharmacyName
    ) {
      onFreeCouponClick(storeItem, getDrugItemList());
    }
  }, [storeItem]);

  return (
    <div className="saveCouponList">
      {!_.isEmpty(notificationError) && (
        <div className="notification visible">
          {notificationError}
          <span
            className="close-button"
            onClick={() => setNotificationError('')}
          >
            ×
          </span>
        </div>
      )}
      {!_.isEmpty(savedCouponData.couponItems) && (
        <div className="clearBtnDiv">
          <button
            className="clearBtn"
            onClick={() => setClearAllCoupons(true)}
            role="link"
          >
            Clear all
          </button>
        </div>
      )}
      {isLoading ? (
        <div className="loaderDiv">
          <Loader />
        </div>
      ) : _.isEmpty(couponItems) ? (
        <NoCoupons />
      ) : (
        <ul className="savedCouponWrapper">
          {couponItems &&
            couponItems
              .filter(couponItem => couponItem.drug.isSpecialtyDrug !== null)
              .map((couponItem, key) => {
                return (
                  <div key={key}>
                    {couponItem.isEditLoading ? (
                      <div className="loaderDiv">
                        <Loader />
                      </div>
                    ) : (
                      <li key={key} className="listsRow">
                        <div className="drugInfoContent">
                          <div className="drugInfoList">
                            <div className="pharmacyImgs desktop-only">
                              <LazyLoadImage
                                src={couponItem.drug.imageUrl}
                                width="72px"
                                height="54px"
                                alt=""
                              />
                            </div>
                            <h3 className="">{couponItem.drug.drugName}</h3>
                            <span>
                              {couponItem.drug.dosage},{' '}
                              {couponItem.drug.displayQuantity} count,{' '}
                              {couponItem?.drug?.drugType
                                ? couponItem?.drug?.drugType
                                : couponItem.drug.isGeneric
                                ? 'Generic'
                                : 'Brand'}{' '}
                              {couponItem.drug.form}
                            </span>
                            {couponItem.drug.isSpecialtyDrug && (
                              <div className="unavailableDrug">
                                This dosage is no longer available. See drug
                                pricing for more details.
                              </div>
                            )}
                          </div>
                          <DeleteEditAction
                            setModal={setIsDeleteCouponDrug}
                            setIsOpened={setIsOpened}
                            setDeleteDrugData={() => {
                              setDataLayerEventObj({ ...couponItem.drug });
                              setDeleteDrugData({
                                ndc: couponItem.drug.ndc,
                                quantity: couponItem.drug.quantity
                              });
                            }}
                          />
                          <div className="drugAction">
                            <div className="desktop-only">
                              <ul className="d-flex actionList">
                                <li
                                  onClick={() => {
                                    couponItem.isEditLoading = true;
                                    setDataLayerEventObj({
                                      ...couponItem.drug
                                    });
                                    setEditDrugData(couponItem.drug);
                                    _.triggerGTMVirtualPageViewEvent({
                                      event: 'savedEditDrug',
                                      drugName: couponItem.drug.drugName,
                                      seoName: couponItem.drug.seoName,
                                      NDC: couponItem.drug.ndc,
                                      drugBrand: couponItem?.drug?.drugType
                                        ? couponItem?.drug?.drugType
                                        : couponItem.drug.isGeneric
                                        ? 'Generic'
                                        : 'Brand',
                                      drugForm: couponItem.drug.form,
                                      drugDosage: couponItem.drug.dosage,
                                      drugQuantity: couponItem.drug.quantity
                                    });
                                    setIsEditCouponDrug(true);
                                  }}
                                  className={
                                    couponItem.drug.isSpecialtyDrug &&
                                    'disabled'
                                  }
                                >
                                  <ActionButton
                                    img="icon-edit.svg"
                                    alt=""
                                    tabIndex="0"
                                    className="themeFocus"
                                  />
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="mobile-only">
                            <ActionButton
                              img="icon-rounded-more.png"
                              alt=""
                              onClick={() => {
                                setDataLayerEventObj({ ...couponItem.drug });
                                setDeleteDrugData({
                                  ndc: couponItem.drug.ndc,
                                  quantity: couponItem.drug.quantity
                                });
                                setEditDrugData(couponItem.drug);
                                setIsOpened(true);
                              }}
                              other={{ width: '24px', height: '24px' }}
                            />
                          </div>
                        </div>
                        {couponItem.coupons.map((coupon, key) => {
                          return (
                            <div key={key} className="pharmacyContent">
                              <LazyLoadImage
                                src="/content/images/icons/icon-rounded-close.png"
                                className="closePharmacy themeFocus"
                                tabIndex="0"
                                alt="close"
                                width="18px"
                                height="18px"
                                onClick={() => {
                                  setDataLayerEventObj({
                                    ...couponItem.drug,
                                    ...coupon
                                  });
                                  setPharmacyData({
                                    ndc: couponItem.drug.ndc,
                                    quantity: couponItem.drug.quantity,
                                    nabp: coupon.nabp,
                                    pharmacy: coupon.pharmacy
                                  });
                                  setIsDeletePharmacy(true);
                                }}
                              />
                              {!_.isEmpty(coupon.pharmacyLogoUrl) ? (
                                <div className="pharmacyImg">
                                  <LazyLoadImage
                                    src={coupon.pharmacyLogoUrl}
                                    width="100px"
                                    height="28px"
                                    alt=""
                                  />
                                </div>
                              ) : (
                                <h3>{coupon.pharmacy}</h3>
                              )}
                              <div className="pharmacyPrice">
                                {!_.isEmpty(coupon.drugLoyaltyPrice) &&
                                !couponItem.drug.isSpecialtyDrug ? (
                                  <span className="priceBlock">
                                    ${coupon.drugLoyaltyPrice}
                                  </span>
                                ) : (
                                  <div className="unavailablePrice">
                                    Price not available
                                  </div>
                                )}
                                <div className="d-flex linkAction pharmacy-item__cta">
                                  <GetFreeCoupon
                                    onClick={() =>
                                      onFreeCouponClick(
                                        coupon,
                                        couponItem?.drug
                                      )
                                    }
                                    className="buttonGetFreeCoupon"
                                  >
                                    <LazyLoadImage
                                      src="/content/images/icons/icon-keyboard-arrow-right.png"
                                      width="24px"
                                      height="26px"
                                      alt="arrow"
                                      tabIndex="0"
                                      className="carrotIcon themeFocus"
                                    />
                                  </GetFreeCoupon>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </li>
                    )}
                  </div>
                );
              })}
          {isModalOpen &&
            !_.isEmpty(selectedCouponData?.coupon?.loyaltyPrice) &&
            !selectedCouponData?.drugData?.isSpecialtyDrug && (
              <div className="loyaltyItem">
                <CouponModal
                  item={getItemList(selectedCouponData?.coupon)}
                  drugData={getDrugData(selectedCouponData?.drugData)}
                  selectedDisplayQuantity={
                    !_.isEmpty(selectedCouponData?.drugData.isCustomQuantity)
                      ? selectedCouponData?.drugData.isCustomQuantity
                      : selectedCouponData?.drugData.displayQuantity
                  }
                  doNotMarket={
                    !_.isEmpty(selectedCouponData?.drugData.deaClassCode)
                  }
                  isModalOpen={isModalOpen}
                  setModalVisibility={value => setModalVisibility(value)}
                  showSignupModal={showSignupModal}
                  setSignupModal={value => setSignupModal(value)}
                  isFromSavedPage
                />
              </div>
            )}
        </ul>
      )}
      {!_.isEmpty(couponItems) && (
        <p className="priceBanner textCenter">Prices are subject to change.</p>
      )}
      {isDeleteCouponDrug && (
        <DialogModel
          setModal={setIsDeleteCouponDrug}
          isModelOpen={isDeleteCouponDrug}
          title="Delete drug?"
          description={
            <Fragment>
              Deleting this drug will remove it <br /> from your Saved Coupons.
            </Fragment>
          }
          handleDeleteSuccess={handleDeleteCouponDrug}
        />
      )}
      {isEditCouponDrug && (
        <DrugDropdownModal
          editDrugData={editDrugData}
          setIsEditCouponDrug={setIsEditCouponDrug}
          handleEditSuccess={handleEditSuccess}
          setDrugItems={setCouponItems}
          drugData={couponItems.map(coupon => ({
            ...coupon,
            isEditLoading: false
          }))}
        />
      )}
      {isClearAllCoupons && (
        <DialogModel
          setModal={setClearAllCoupons}
          isModelOpen={isClearAllCoupons}
          title="Clear All?"
          description={
            <Fragment>
              This will delete all your <br /> Saved Coupons
            </Fragment>
          }
          handleDeleteSuccess={handleDeleteAllCoupons}
        />
      )}
      {isDeletePharmacy && (
        <DialogModel
          setModal={setIsDeletePharmacy}
          isModelOpen={isDeletePharmacy}
          title="Remove this coupon?"
          description=""
          handleDeleteSuccess={handleDeletePharmacy}
          deleteButtonText="Remove"
        />
      )}
      {isOpened && (
        <EditViewModal
          isEditDisabled={editDrugData.isSpecialtyDrug}
          isFromSaveCoupon={true}
          setEditViewModal={setIsOpened}
          setIsDeleteCouponDrug={setIsDeleteCouponDrug}
          setIsEditCouponDrug={setIsEditCouponDrug}
          dataLayerEventObj={dataLayerEventObj}
          setDrugItems={setCouponItems}
          drugItems={couponItems}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    getSavedCoupons: () => dispatch(getSavedCoupons())
  };
};

function mapStateToProps(state) {
  return {
    savedCouponData: state.userDrugs.savedCoupons
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainSaveCouponsList);
